import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";
import { err, ok, Result } from "neverthrow";
import {
  HttpRoadEvent,
  HttpRoadEventListResponse,
  IRoadEventsCollectionParser,
} from "../lineInfoRepository.types";
import { IRoadEvent, IRoadEventsCollection } from "@/domain/entities/roadEvent";

function parseRoadEvent(data: HttpRoadEvent): IRoadEvent {
  const roadEvent: IRoadEvent = {
    uid: data.uid,
    externalIncidentId: data.externalIncidentId,
    title: data.title,
    lat: data.lat,
    lng: data.lng,
    beginDtm: data.useBeginDtm,
    endDtm: data.useEndDtm,
    incidentLaneName: data.incidentLaneName,
    incidentTypeName: data.incidentTypeName,
    incidentGradeName: data.incidentGradeName,
    incidentTrafficName: data.incidentTrafficName,
    incidentBlockName: data.incidentBlockName,
  };
  return roadEvent;
}

@injectable()
export class RoadEventsCollectionParser implements IRoadEventsCollectionParser {
  constructor() {}

  toDomain(
    response: HttpRoadEventListResponse
  ): Result<IRoadEventsCollection, ParseError> {
    try {
      const totalCount = response.totalCount;
      const roadEvents = response.data.map(parseRoadEvent);
      const roadEventsCollection: IRoadEventsCollection = {
        list: roadEvents,
        totalCount: totalCount ?? 0,
      };
      return ok(roadEventsCollection);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
